import { ChevronRight, ExpandMoreOutlined } from "@mui/icons-material";
import { Breadcrumbs, IconButton, Link, Skeleton, Stack, Typography } from "@mui/material";
import React from "react";
import { Link as RouterLink } from "react-router";
import { AssetIconProps } from "../../../Misc/AssetIcon/asset-icon";

interface ITreeBreadcrumbProps {
  treeObj: TCrumbProps[];
}

export type TCrumbProps = {
  name: string;
  link: string;
  icon?: React.ReactNode;
};

export const TreeBreadcrumb: React.FC<ITreeBreadcrumbProps> = (props) => {
  const { treeObj } = props;
  return (
    <Breadcrumbs
      maxItems={4}
      separator={<ChevronRight sx={{ color: "text.tiers", width: "16px", height: "16px" }} />}
      sx={{ ".MuiBreadcrumbs-separator": { margin: 0 }, ".MuiBreadcrumbs-ol": { flexWrap: "nowrap" } }}
    >
      {treeObj.map((item, index) =>
        index === treeObj.length - 1 ? (
          <Stack key={`link-${index}`} direction={"row"} alignItems={"center"} gap={0.25} p={0.25} pl={0.5}>
            <Stack direction={"row"} alignItems={"center"} gap={0.5}>
              {item.icon && item.icon}
              <Typography variant="subtitle1" fontWeight={500} color="text.primary">
                {item.name}
              </Typography>
            </Stack>
            {/* <IconButton color="ghost" size="small">
              <ExpandMoreOutlined />
            </IconButton> */}
          </Stack>
        ) : (
          <Link
            underline="none"
            component={RouterLink}
            key={index}
            to={item.link}
            variant="body1"
            color="text.secondary"
            sx={(theme) => ({
              fontWeight: 400,
              px: 0.5,
              py: 0.5,
              borderRadius: "6px",
              textWrap: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
              "&:hover": { backgroundColor: theme.palette.backgroundAlpha.hover, color: "text.primary" },
              transition: theme.transitions.create(["background-color", "color"], {
                duration: theme.transitions.duration.short,
                easing: theme.transitions.easing.easeOut,
              }),
            })}
          >
            {item.name}
          </Link>
        )
      )}
    </Breadcrumbs>
  );
};

export const TreeBreadcrumbSkeleton = () => {
  return (
    <Breadcrumbs
      maxItems={5}
      separator={<ChevronRight sx={{ color: "text.tiers", width: "16px", height: "16px" }} />}
      sx={{ ".MuiBreadcrumbs-separator": { margin: 0 } }}
    >
      <Skeleton variant="rounded" width={100} />
      <Skeleton variant="rounded" width={100} />
      <Skeleton variant="rounded" width={100} />
    </Breadcrumbs>
  );
};
